import * as React from "react";

interface Props {}

export const PaymentSuccessSvg = (props: Props) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<circle cx={20} cy={20} r={20} fill="url(#paint0_linear_1_5402)" />
		<path
			d="M26.1562 8.6875C23.3131 8.6875 21 11.1548 21 14.1875C21 14.9176 21.1403 15.612 21.3835 16.25H10.6445C10.2886 16.25 10 16.5578 10 16.9375V29.3125C10 29.6922 10.2886 30 10.6445 30H28.7344C29.0903 30 29.3789 29.6922 29.3789 29.3125V18.4459C30.5484 17.4368 31.3555 15.9132 31.3555 14.1875C31.3555 11.1548 28.9994 8.6875 26.1562 8.6875Z"
			fill="white"
		/>
		<path
			d="M14.5547 25.875H13.2656C12.9094 25.875 12.6211 26.1825 12.6211 26.5625C12.6211 26.9425 12.9094 27.25 13.2656 27.25H14.5547C14.9109 27.25 15.1992 26.9425 15.1992 26.5625C15.1992 26.1825 14.9109 25.875 14.5547 25.875ZM18.4219 25.875H17.1328C16.7766 25.875 16.4883 26.1825 16.4883 26.5625C16.4883 26.9425 16.7766 27.25 17.1328 27.25H18.4219C18.7781 27.25 19.0664 26.9425 19.0664 26.5625C19.0664 26.1825 18.7781 25.875 18.4219 25.875ZM18.4219 19H13.2656C12.9094 19 12.6211 19.3075 12.6211 19.6875V21.0625C12.6211 21.4425 12.9094 21.75 13.2656 21.75H18.4219C18.7781 21.75 19.0664 21.4425 19.0664 21.0625V19.6875C19.0664 19.3075 18.7781 19 18.4219 19ZM22.2891 25.875H21C20.6437 25.875 20.3555 26.1825 20.3555 26.5625C20.3555 26.9425 20.6437 27.25 21 27.25H22.2891C22.6453 27.25 22.9336 26.9425 22.9336 26.5625C22.9336 26.1825 22.6453 25.875 22.2891 25.875ZM26.1562 25.875H24.8672C24.5109 25.875 24.2227 26.1825 24.2227 26.5625C24.2227 26.9425 24.5109 27.25 24.8672 27.25H26.1562C26.5125 27.25 26.8008 26.9425 26.8008 26.5625C26.8008 26.1825 26.5125 25.875 26.1562 25.875ZM26.1562 8C22.9575 8 20.3555 10.7755 20.3555 14.1875C20.3555 17.5995 22.9575 20.375 26.1562 20.375C29.355 20.375 32 17.5995 32 14.1875C32 10.7755 29.355 8 26.1562 8ZM28.757 13.073L25.6451 16.3924C25.5192 16.5267 25.3543 16.5938 25.1895 16.5938C25.0246 16.5938 24.8596 16.5267 24.7338 16.3924L23.2332 14.7918C22.9815 14.5232 22.9815 14.0881 23.2332 13.8196C23.485 13.5511 23.8929 13.5511 24.1446 13.8196L25.1895 14.9341L27.8456 12.1008C28.0974 11.8323 28.5053 11.8323 28.757 12.1008C29.0088 12.3694 29.0088 12.8044 28.757 13.073Z"
			fill="#0ABA9E"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_1_5402"
				x1={20}
				y1={-7}
				x2={20}
				y2={40}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#0ABA9E" />
				<stop offset={0.9} stopColor="#17D5B7" />
			</linearGradient>
		</defs>
	</svg>
);
